import React, { useRef, useEffect, useContext } from "react";

import {
  NotificationAdd,
  NotificationsActive,
  Work,
  AccessTime,
  Delete,
  CancelPresentation,
} from "@mui/icons-material";

import {
  Button,
  Card,
  CardContent,
  CardActions,
  Alert,
  Box,
  Typography,
  Grid,
} from "@mui/material/";

import { CustomIcons } from "../../../Components/helpers/Helpers";
import { CustomButtonPlusIcon } from "../../../Components/Common/Design/CustomButtonPlusIcon";
import { PermissionContext } from "../../../Components/Context/Context";

import {
  LocalizationProvider,
  DesktopDateTimePicker,
} from "@mui/x-date-pickers";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/es";

const AlertsTab = ({
  addDataTab,
  setAddDataTab,
  editDataTab,
  setEditDataTab,
  Editor,
  editorState,
  onEditorChange,
  handleCancelDataTabs,
  handleSubmitDataTabs,
  dataCaseNotesAlertsMessages,
  handleDeleteDataTabs,
  setSelectionStyleAlert,
  selectionStyleAlert,
  setDateConfig = () => {},
  dateConfig,
}) => {
  const editorWrapperRef = useRef(null);
  const { can } = useContext(PermissionContext);
  const canDeleteAlert = can("cases", "deletealerts");
  const hasAddAlert = can("cases", "addalerts");

  const CardAlerts = ({
    lawyer,
    createdAt,
    message,
    alertId,
    alertLawyerId,
    alertCaseId,
  }) => {
    return (
      <Card
        sx={{
          minWidth: 275,
          color: "#676a6c",
          boxShadow: "-5px 3px 10px -1px #e1d1a082 !important",
        }}>
        <CardContent className="alignItemsAndLeft">
          <NotificationsActive
            color="warning"
            sx={{ marginRight: "10px" }}
            className="alignItemsAndLeft blinking"
          />
          <div dangerouslySetInnerHTML={{ __html: message }} />
        </CardContent>
        <CardActions
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
            background:
              "linear-gradient(to right, #ede60233 0%, #ede60233 30%, transparent 80%)",
            padding: "0px 16px",
          }}>
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <Work />
            {lawyer && !lawyer.includes("undefined") ? lawyer : ""}

            <AccessTime />
            {createdAt ? dayjs(createdAt).format("DD/MM/YYYY HH:mm") : ""}
          </div>
          {/* Botones opcionales */}
          {!editDataTab && (
            <div>
              {/* <Button
                 color="info"
                 size="small"
                 onClick={() => {
                   setEditDataTab(true);
                   setAddDataTab(true);
                   setAlertId(alertId);
                   setSelectionStyleAlert(alertId);
                   setAlertLawyerId(alertLawyerId);
                   setAlertCaseId(alertCaseId);
                   handleEditEditorDataTabs(message);
                 }}
               >
                 <Edit />
                 Editar
               </Button> */}
              {canDeleteAlert && (
                <Button
                  color="error"
                  size="small"
                  onClick={() =>
                    handleDeleteDataTabs(alertId, message, "alerts", "alerta")
                  }>
                  <CustomIcons
                    icon={Delete}
                    width={"20px"}
                    height={"20px"}
                    marginRight={"5px"}
                  />
                  <span className="reOrderTextButton">Eliminar</span>
                </Button>
              )}
            </div>
          )}
        </CardActions>
      </Card>
    );
  };

  const handleChangeAlertDate = (newValue) => {
    if (!newValue) return;

    setDateConfig(dayjs(newValue));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target && typeof event.target.click === "function") {
        event.target.click();
      } else if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box>
      <Box sx={{ textAlign: "right", marginY: "10px" }}>
        {addDataTab != true && editDataTab != true && hasAddAlert && (
          <CustomButtonPlusIcon
            color={"warning"}
            icon={NotificationAdd}
            text={"Agregar Alerta"}
            handleFunction={() => setAddDataTab(true)}
            position="start"
            variant={"contained"}
          />
        )}
      </Box>
      <Box sx={{ background: "white" }}>
        {addDataTab ? (
          <div style={{ marginBottom: "10px", padding: "10px" }}>
            <Box sx={{ width: "100%", my: 1 }}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="es">
                <DesktopDateTimePicker
                  label="Fecha y hora de la alerta"
                  value={dateConfig}
                  onChange={handleChangeAlertDate}
                  sx={{ width: "100%" }}
                  ampm={false} // formato 24h
                />
              </LocalizationProvider>
            </Box>
            <div
              ref={editorWrapperRef}
              style={{
                border: "1px solid #ddd",
                minHeight: "160px",
                marginBottom: "10px",
                padding: "10px",
              }}>
              <Editor
                editorState={editorState}
                onEditorStateChange={onEditorChange}
                toolbar={{
                  options: [
                    "inline",
                    "fontSize",
                    "list",
                    "textAlign",
                    "history",
                  ],
                }}
              />
            </div>

            {(editDataTab || addDataTab) && (
              <div
                style={{
                  textAlign: "end",
                  marginBottom: "20px",
                  gap: 20,
                  display: "flex",
                  justifyContent: "end",
                }}>
                {addDataTab && !editDataTab && (
                  <CustomButtonPlusIcon
                    color={"error"}
                    icon={CancelPresentation}
                    text={"Cancelar Alerta"}
                    handleFunction={() => handleCancelDataTabs(false)}
                    position="start"
                    variant={"outlined"}
                  />
                )}

                {editDataTab && (
                  <CustomButtonPlusIcon
                    color={"error"}
                    icon={CancelPresentation}
                    text={"Cancelar Edición"}
                    handleFunction={() => handleCancelDataTabs(false)}
                    position="start"
                    variant={"outlined"}
                  />
                )}

                <CustomButtonPlusIcon
                  color={"success"}
                  icon={CancelPresentation}
                  text={editDataTab ? "GUARDAR EDICIÓN" : "GUARDAR ALERTA"}
                  handleFunction={() =>
                    handleSubmitDataTabs("alerts", "Alerta", {
                      date: dateConfig
                        ? dayjs(dateConfig).format("YYYY-MM-DD HH:mm:ss")
                        : null,
                    })
                  }
                  position="start"
                  variant={"contained"}
                  id="alertmessage"
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Box>

      <Box
        sx={{
          maxHeight: "700px",
          overflowY: "auto",
          background: "white",
          borderRadius: "4px",
          padding: "10px",
        }}>
        {/* <Typography variant="body2">Alertas</Typography> */}
        {dataCaseNotesAlertsMessages?.alerts?.length > 0 ? (
          dataCaseNotesAlertsMessages?.alerts?.map((element, index) => (
            <li
              key={index}
              style={{
                listStyle: "none",
                padding: "5px",
              }}>
              <CardAlerts
                alertsCaseId={element.case_id}
                alertsLawyerId={element.lawyer_relation?.id}
                lawyer={
                  element.lawyer_relation?.name +
                  " " +
                  element.lawyer_relation?.surname
                }
                createdAt={element.date}
                message={element.message}
                alertId={element.id}
              />
            </li>
          ))
        ) : (
          <Alert severity="info">Sin alertas para mostrar</Alert>
        )}
      </Box>
    </Box>
  );
};

export default AlertsTab;
